export default __webpack_public_path__ + "static/media/tron-icon.09d4582e.svg";